<template>
  <Tinybox :images="images" v-model="index" />
</template>

<script>
import Tinybox from "vue-tinybox";

export default {
  data: () => ({
    index: null,
    images: [], //  { src }[]
  }),
  created() {
    window.showGalleryWidget = (images, index) => {
      this.images = images;

      if (this.images.length) {
        this.index = index;
      }
    };
  },
  components: {
    Tinybox,
  },
};
</script>
